import { UPDATE_API_CALL_STATUS, ApiStatus, CLEAR_API_CALL_STATUS } from './index.models'

export function updateApiCallStatus(data: ApiStatus) {
  return {
    type: UPDATE_API_CALL_STATUS,
    payload: data,
  }
}
export function clearApiCallStatus(data: any) {
  return {
    type: CLEAR_API_CALL_STATUS,
    payload: data,
  }
}
